import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import React from "react";
import { useDispatch } from "react-redux";
import {
  SubirArchivoExcel,
  DescargarPlantillaExcel,
} from "../../../actions/contrataciones/contratacionesConvenios";

export const ConveniosPlantilla = (props) => {
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleChangeFile = (e) => {
    dispatch(SubirArchivoExcel(e.target.files[0]));
    e.target.value = null;
  };

  const downloadFile = () => {
    dispatch(DescargarPlantillaExcel());
  };

  return (
    <React.Fragment>
      <ButtonGroup
        variant="contained"
        color="inherit"
        ref={anchorRef}
        aria-label="split button"
        style={{
          boxShadow: "none",
          width: "100%",
          justifyContent: "center",
          marginTop: "1rem",
        }}
      >
        {selectedIndex === 0 && (
          <>
            <input
              accept="*/*"
              //   className={classes.input}
              style={{ display: "none" }}
              id="selectArchivoExcel"
              multiple
              type="file"
              onChange={handleChangeFile}
            />
            <Button
              component="span"
              variant="contained"
              color="primary"
              startIcon={<CloudUploadIcon />}
              style={{ borderRadius: "3px 0px 0px 3px" }}
              onClick={() =>
                document.querySelector(`#selectArchivoExcel`).click()
              }
            >
              Subir Plantilla
            </Button>
          </>
        )}
        {selectedIndex === 1 && (
          <Button
            component="span"
            variant="contained"
            color="primary"
            style={{ borderRadius: "3px 0px 0px 3px" }}
            startIcon={<CloudDownloadIcon />}
            onClick={downloadFile}
          >
            Descargar Plantilla{" "}
          </Button>
        )}
        <Button
          color="primary"
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        style={{ zIndex: 1 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top " : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu">
                  <MenuItem
                    selected={0 === selectedIndex}
                    onClick={(event) => handleMenuItemClick(event, 0)}
                  >
                    Subir Plantilla
                  </MenuItem>
                  <MenuItem
                    selected={1 === selectedIndex}
                    onClick={(event) => handleMenuItemClick(event, 1)}
                  >
                    Descargar Plantilla
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
};
